module.exports = __webpack_public_path__ + "static/media/pink-p.4856e7a9.svg";